import { Controller } from '@hotwired/stimulus'
import { tns } from 'tiny-slider'

export default class PortfolioController extends Controller {
  static targets = ['gallery', 'prev', 'next', 'carousel']

  static values = {
    mode: { type: String, default: 'gallery' }
  }

  connect () {
    this.render()
  }

  render () {
    new tns({
      container: this.galleryTarget,
      mode: this.modeValue,
      items: 1,
      slideBy: 1,
      loop: false,
      swipeAngle: false,
      // speed: 300,
      edgePadding: 0,
      // animateIn: 'fadeIn',
      // animateOut: 'fadeOut',
      nav: this.modeValue === 'gallery',
      nextButton: this.nextTarget,
      prevButton: this.prevTarget,
      autoplay: false,
      autoplayTimeout: 10000,
      autoplayButtonOutput: false,
      responsive: {
        640: {
          items: this.modeValue === 'carousel' ? 2 : 1,
        },
        1024: {
          items: this.modeValue === 'carousel' ? 3 : 1,
          nav: false,
        }
      }
    })
  }
}
